import { render, staticRenderFns } from "./PlatformTour.vue?vue&type=template&id=4feb3dd0&scoped=true"
var script = {}
import style0 from "./PlatformTour.vue?vue&type=style&index=0&id=4feb3dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb3dd0",
  null
  
)

export default component.exports